/******************************************************************************************
 *	User Service
 *******************************************************************************************
 *
 * Contains information regarding current (logged in) user, including reseller membership and roles.
 */
(function() {


  angular.module('rcServices.user', []).service(
    'User',
    /* @ngInject */
    function($log, $q, CurtainNotifications, RC_USER_ROLES, RcUserRoles, Redirector, ResellerOrg) {
      var user = {
        id: null,
        firstName: null,
        lastName: null,
        email: null,
        role: null, //Current user role, defaults to lowest user role in getter function
        availableRoles: null, //All available roles for this user as returned by the JIL authorization endpoint
        reseller: null,
        impersonatedReseller: null //License Admin can impersonate resellers
      };

      /*=== User Info ===*/

      //Set user data
      this.set = function(id, firstName, lastName, email) {
        user.id = id;
        user.firstName = firstName;
        user.lastName = lastName;
        user.email = email;

        $log.info('%cUser ID ::', 'font-weight:bold;color:#009966;', id);
      };

      //Clear user data
      this.clear = function() {
        for (var prop in user) {
          user[prop] = null;
        }
      };

      //Get user ID
      this.getID = function() {
        return user.id;
      };

      /*=== User Resellers ===*/

      //Set reseller info
      this.setReseller = function(data) {
        user.reseller = new ResellerOrg(data);

        $log.info(
          '%cReseller Org ID ::',
          'font-weight:bold;color:#009966;',
          user.reseller ? user.reseller.id : 'n/a'
        );
      };
      this.setImpersonatedReseller = function(data) {
        user.impersonatedReseller = new ResellerOrg(data);

        $log.info(
          '%cImpersonated Reseller Org ID ::',
          'font-weight:bold;color:#009966;',
          user.impersonatedReseller ? user.impersonatedReseller.id : 'n/a'
        );
      };

      //Getters for reseller object, ID and name
      this.getReseller = function() {
        return user.reseller || user.impersonatedReseller;
      };
      this.getResellerID = function() {
        if (user.reseller) {
          return user.reseller.id;
        } else if (user.impersonatedReseller) {
          return user.impersonatedReseller.id;
        }
        return null;
      };
      this.getResellerName = function() {
        if (user.reseller) {
          return user.reseller.name;
        } else if (user.impersonatedReseller) {
          return user.impersonatedReseller.name;
        }
        return null;
      };

      //Clear impersonated reseller
      this.clearImpersonatedReseller = function() {
        user.impersonatedReseller = null;
      };

      /*=== User Roles ===*/

      //Receives data as returned by the JIL authorization endpoint and parse it into available roles for current user, current role and if the case, user resellers.
      this.setRoles = roles => {
        $log.info('%cUser Roles ::', 'font-weight:bold;color:#009966;', roles);

        //Reset available roles and current role
        user.availableRoles = roles;
        user.role = null;

        if (roles) {
          //Then decide current role by choosing highest access level role available to this user and, if the case, also set current reseller
          var rolePriority = RcUserRoles.getRolePriority();
          for (var i = 0, count = rolePriority.length; i < count; i++) {
            if (roles[rolePriority[i]]) {
              var roleExists = RC_USER_ROLES.hasOwnProperty(rolePriority[i]);

              if (roleExists) {
                user.role = rolePriority[i];

                $log.info('%cCurrent User Role ::', 'font-weight:bold;color:#009966;', user.role);

                //Get the first reseller org for the current role and if present, set it as the user's Reseller Org
                //The default now is the first reseller in the list.
                //In the future this will probably be configurable by the user.
                var defaultResellerOrg = roles[rolePriority[i]][0];
                if (defaultResellerOrg) {
                  this.setReseller(defaultResellerOrg);
                }

                //Set default Redirector path
                Redirector.setDefaultStateName(RcUserRoles.getStateNameByRole(user.role));

                break; //First role from high to low wins
              }
            }
          }
        }

        //If user.role is still not set after iterating through roles returned by JIL authorization endpoint, we have a problem.
        if (!user.role) {
          //FR: TODO ~ Logout page is no longer in RC, so the Curtain Notification won't be visible for very long.
          CurtainNotifications.show(CurtainNotifications.ERROR, 'login.notifications.accessDenied');
          Redirector.go('logout');
        }
      };

      //Return user role. Defaults to lowest user role if not set.
      this.getRole = function() {
        return user.role || RcUserRoles.getLowestUserRole();
      };

      this.isResellerMember = function() {
        return RC_USER_ROLES[user.role] === RC_USER_ROLES.RESELLER_TEAM_MEMBER;
      };
      this.isResellerAdmin = function() {
        return RC_USER_ROLES[user.role] === RC_USER_ROLES.RESELLER_TEAM_ADMIN;
      };
      this.isLicenseAdminReadOnly = function() {
        return RC_USER_ROLES[user.role] === RC_USER_ROLES.LICENSE_ADMIN_READ_ONLY;
      };
      //We include LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER in this category
      this.isLicenseAdminReadWrite = function() {
        return (
          RC_USER_ROLES[user.role] === RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE ||
          RC_USER_ROLES[user.role] === RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER
        );
      };
      this.isLicenseAdminReadWriteRefreshCustomer = function() {
        return RC_USER_ROLES[user.role] === RC_USER_ROLES.LICENSE_ADMIN_READ_WRITE_REFRESH_CUSTOMER;
      };
      this.isLicenseAdmin = function() {
        return this.isLicenseAdminReadOnly() || this.isLicenseAdminReadWrite();
      };
      this.isResellerAllowedToViewBanner = function () {
        if (user.reseller) {
          return user.reseller.isResellerCountryCanViewBanner;
        } else if (user.impersonatedReseller) {
          return user.impersonatedReseller.isResellerCountryCanViewBanner;
        } else {
          return null;
        }
      };
      this.isResellerAllowlistedToCreateVIP = function (){
        if (user.reseller) {
          return user.reseller.isResellerAllowlisted;
        } else if (user.impersonatedReseller) {
          return user.impersonatedReseller.isResellerAllowlisted;
        } else {
          return null;
        }
      };
      this.isResellerAllowedToCreateVIP = function (){
        return this.isResellerAllowlistedToCreateVIP() && (this.isResellerMember() || this.isResellerAdmin() || this.isLicenseAdmin());
      };
      this.isResellerAllowedToViewEduGovBanner = function () {
        if (user.reseller ) {
          return user.reseller.isResellerCanViewEduGovBanner();
        } else if (user.impersonatedReseller) {
          return user.impersonatedReseller.isResellerCanViewEduGovBanner();
        } else {
          return false;
        }
      };
    }
  );
})();
